const { hostname } = window.location;

export const isLocalhost = hostname === 'localhost';
export const isDev = hostname.includes('frontend-landing-dev');
export const isUat = hostname.includes('frontend-landing-preprod');

function setTopLevelDomain() {
  const url = new URL(window.location.href);
  const domainParts = url.hostname.split('.');

  return domainParts[domainParts.length - 1];
}

let customDomain = setTopLevelDomain();

if (isDev || isLocalhost || isUat) {
  const localDomain = localStorage.getItem('localDomain');

  if (localDomain) {
    customDomain = localDomain;
  }
}

export const domain = customDomain;
